export default {
  adminUiEndpoint: 'https://app.playable.com',
  apiEndpoint: 'https://campaign-api-rest.prod.playable.com',
  leaderboardUI: 'https://cdn.prod.leadfamly.com/frontend/leaderboard/leaderboard.js',
  facebookId: '0',
  sentry: {
    dsn: 'https://46f7effaa6c94756ba9e977d80c75462@o367362.ingest.sentry.io/4504678627409920', // nosem
    environment: 'prod'
  },
  adminUiEndpointOverwrites: [
    {
      lookup: 'gameplay.lobyco.com',
      overwrite: 'https://gameplay.lobyco.com'
    },
    {
      lookup: 'app.playable.com',
      overwrite: 'https://app.playable.com'
    }
  ],
  analyticsEndpoint: 'https://collector.prod.data.playable.com/'
};
